import { Table, Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import { es } from "date-fns/locale";

// AUDITORIA-CLINICA-FASE-1 -- tabla 100% lectura. La UNICA accion de fila es
// "Ver auditoría" (abre el drawer de detalle) -- NUNCA "Editar" (no hay
// ningún endpoint de escritura habilitado en esta fase).
const fechaFmt = (t) => (t ? format(new Date(t), "dd/MM/yyyy HH:mm", { locale: es }) : "—");

// AUDITORIA-CLINICA-WORKFLOW-44 §25: el estado de REVISION se muestra
// SIEMPRE junto al conteo de correcciones, pero son independientes --
// "AUDITADA | Correcciones 0" es un resultado valido y frecuente (la atención
// se revisó y estaba correcta).
export const ESTADO_AUDITORIA_TAG = {
    PENDIENTE: { color: "default", label: "Pendiente" },
    EN_PROCESO: { color: "processing", label: "En proceso" },
    AUDITADA: { color: "success", label: "Auditada" },
};

function AuditoriaClinicaTabla({ rows, loading, page, pageSize, total, onChange, onVerAuditoria }) {
    const columns = [
        { title: "ID Cita", dataIndex: "idcita", width: 80 },
        { title: "Fecha", dataIndex: "fecha", width: 140, render: fechaFmt },
        { title: "Paciente", dataIndex: "paciente", width: 200, render: (t) => t || "—" },
        { title: "Documento", dataIndex: "documento", width: 120, render: (t) => t || "—" },
        { title: "Doctor", dataIndex: "doctor", width: 160, render: (t) => t || "SIN DETERMINAR" },
        { title: "Clínica", dataIndex: "clinica", width: 160, render: (t) => t || "—" },
        {
            title: "Cobertura", dataIndex: "tipo_cobertura", width: 120,
            render: (t) => <Tag color={t === "SEGURO" ? "blue" : t === "PARTICULAR" ? "green" : "default"}>{t || "SIN_DETERMINAR"}</Tag>,
        },
        { title: "Aseguradora", dataIndex: "aseguradora", width: 150, render: (t) => t || "—" },
        { title: "Plan", dataIndex: "plan", width: 130, render: (t) => t || "—" },
        { title: "Estado cita", dataIndex: "estado_cita", width: 120, render: (t) => t || "—" },
        {
            title: "Estado auditoría", dataIndex: "estado_auditoria", width: 130, align: "center",
            render: (t) => {
                const tag = ESTADO_AUDITORIA_TAG[t || "PENDIENTE"] || { color: "default", label: t };
                return <Tag color={tag.color} data-testid={`estado-auditoria-${t || "PENDIENTE"}`}>{tag.label}</Tag>;
            },
        },
        {
            title: "Correcciones", dataIndex: "cantidad_correcciones", width: 110, align: "center",
            render: (t) => (t > 0 ? <Tag color="orange">{t}</Tag> : <Tag>0</Tag>),
        },
        { title: "Última corrección", dataIndex: "ultima_correccion", width: 150, render: fechaFmt },
        {
            title: "Acciones", key: "acciones", width: 130, fixed: "right",
            render: (_, record) => (
                <Button size="small" icon={<EyeOutlined />} onClick={() => onVerAuditoria(record.idcita)}>
                    Ver auditoría
                </Button>
            ),
        },
    ];

    return (
        <Table
            size="small"
            bordered
            rowKey="idcita"
            loading={loading}
            columns={columns}
            dataSource={rows}
            scroll={{ x: 1740, y: 520 }}
            locale={{ emptyText: "No se encontraron atenciones para los filtros aplicados." }}
            pagination={{
                current: page, pageSize, total, showSizeChanger: true,
                showTotal: (t) => `${t} atenciones`,
            }}
            onChange={onChange}
        />
    );
}

export default AuditoriaClinicaTabla;
